<template>
  <div class="company-auth">
    <div class="header">
      <mm-steps :current="step">
        <mm-step :title="$t('auth.step1')" />
        <mm-step :title="$t('auth.step2')" />
        <mm-step :title="$t('auth.step3')" />
      </mm-steps>
    </div>
    <component :is="stepCom" />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import {
    VERIFY_STATUS_NONE,
    VERIFY_STATUS_NONE_OVERSEA,
    VERIFY_STATUS_PENDING,
    VERIFY_STATUS_PASS,
    VERIFY_STATUS_REFUSE,
    VERIFY_STATUS_REFUSE_OVERSEA,
  } from '@utils/constants'
  import Step1 from './components/Step1'
  import Step2 from './components/Step2'
  import Step3 from './components/Step3'

  export default {
    name: 'CompanyAuth',
    computed: {
      ...mapGetters('main', ['verifyStatus']),
      step () {
        const stepMap = {
          [VERIFY_STATUS_NONE]: 0,
          [VERIFY_STATUS_NONE_OVERSEA]: 0,
          [VERIFY_STATUS_PENDING]: 1,
          [VERIFY_STATUS_PASS]: 2,
          [VERIFY_STATUS_REFUSE]: 0,
          [VERIFY_STATUS_REFUSE_OVERSEA]: 0,
        }
        return stepMap[this.verifyStatus]
      },
      stepCom () {
        const statusMap = {
          [VERIFY_STATUS_NONE]: Step1,
          [VERIFY_STATUS_NONE_OVERSEA]: Step1,
          [VERIFY_STATUS_PENDING]: Step2,
          [VERIFY_STATUS_PASS]: Step3,
          [VERIFY_STATUS_REFUSE]: Step1,
          [VERIFY_STATUS_REFUSE_OVERSEA]: Step1,
        }
        return statusMap[this.verifyStatus]
      }
    },
  }
</script>

<style lang="scss" scoped>
  .company-auth{
    display: flex;
    flex-direction: column;
    font-size: 12px;
    background: #fff;
  }
  .header{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 106px;
    padding: 0 98px;
    background: #F5FAFF;
    user-select: none;
  }
</style>
